import { render, staticRenderFns } from "./LossToTrukkinPopup.vue?vue&type=template&id=0c895a09&scoped=true&"
import script from "./LossToTrukkinPopup.vue?vue&type=script&lang=js&"
export * from "./LossToTrukkinPopup.vue?vue&type=script&lang=js&"
import style0 from "./LossToTrukkinPopup.vue?vue&type=style&index=0&id=0c895a09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c895a09",
  null
  
)

export default component.exports